import type { ReconnectStrategy } from './types';

type Options = {
  attemptCount?: number;
  timeout?: number;
};

export function reconnectStrategy({
  attemptCount = 5,
  timeout = 5000
}: Options = {}): ReconnectStrategy {
  return ({ reconnectCount }) => {
    return new Promise((resolve) => {
      if (reconnectCount > attemptCount) {
        resolve(false);
        return;
      }

      setTimeout(
        () => {
          resolve(true);
        },
        reconnectCount * timeout
      );
    });
  };
}
